import Article from "@/clas/Article";
import { EventBus } from "@/main";
import moment from "moment";
import axios from "axios";
import store from "../store";

export default class SalesOder {
	constructor(salesorder) {
		this.salesorder = salesorder;

		this.iva = 0.16;

		this.discount = 0;
	}

	setDiscount(discount) {
		this.discount = discount;
	}

	subTotal() {
		var subTotal = 0;

		this.salesorder.articles.forEach((article) => {
			var a = new Article(article);

			subTotal =
				subTotal + parseFloat(a.price()) * parseFloat(article.amount);
		});

		return subTotal;
	}

	total() {
		return (
			parseFloat(this.subTotal()) -
			parseFloat(this.discountAmount()) +
			parseFloat(this.ivaAmount())
		);
	}

	ivaAmount() {
		return ((this.subTotal() - this.discountAmount()) * this.iva).toFixed(
			2
		);
	}

	discountAmount() {
		if (this.hasDiscount()) {
			return (this.subTotal() / 100) * this.salesorder.discount;
		}

		return 0;
	}

	hasDiscount() {
		if (
			this.salesorder.discount !== undefined &&
			this.salesorder.discount !== null
		) {
			return true;
		}

		return false;
	}

	priceFormat(price) {
		return Intl.NumberFormat("ES-MX", {
			style: "currency",
			currency: "MXN",
		}).format(price);
	}

	weight() {
		let weight = 0;

		this.salesorder.articles.forEach((article) => {
			weight = weight + article.weight * article.amount;
		});

		return Number.parseFloat(weight).toFixed(2);
	}

	templateCreate() {
		try {
			let note = "";

			let shipping_method = this.salesorder.shipping_method;

			let comments = shipping_method
				? `Método de envío: ${shipping_method.name}`
				: "";

			var tasa = this.salesorder.discount;

			let direccion = this.salesorder.delivery_address;
			let fletera = this.salesorder.freight;
			let nombre_de_contacto = this.salesorder.contac_name;
			let telefono_de_contacto = this.salesorder.contac_phone;

			if (this.salesorder.note) {
				comments = `${comments},  NOTA: ${this.salesorder.note}`;
			}

			return this.salesorder.articles.map((article) => {
				return {
					id: `${moment().format("YYMD")}${this.salesorder.id}`,
					id_cliente: this.salesorder.customer.id,
					ubicacion: "CEDIS PT FABELA",
					departamento: "CEDIS FABELA",
					estado: "APROBACION PENDIENTE",
					descuento: "Descuento socio",
					fecha: moment().format("DD.MM.YYYY"),
					articulo: article.id,
					precio: article.price,
					cantidad: article.amount,
					importe: article.price * article.amount,
					tasa: tasa ? `-${tasa}%` : `0%`,
					metodo_envio: shipping_method ? shipping_method.id : "",
					nota: note,
					comentarios_adicionales: comments,
					direccion: direccion,
					fletera: fletera,
					nombre_de_contacto: nombre_de_contacto,
					telefono_de_contacto: telefono_de_contacto,
				};
			});
		} catch (error) {
			EventBus.$emit("Error", { error: error, errorsShow: true });
		}
	}

	async export(sales_orders_ids) {
		try {
			let response = await axios.get(
				`${process.env.VUE_APP_API_SERVER}/auth/store/salesorder/export`,
				{
					params: {
						sales_orders: sales_orders_ids,
					},
					headers: {
						Authorization: `Bearer ${store.state.acount.token}`,
					},
				}
			);

			return response.data.data;
		} catch (error) {
			throw error;
		}
	}

	async exportedUpdate() {
		try {
			await this.exportedUpdateMasive([this.salesorder.id]);
		} catch (error) {
			throw error;
		}
	}

	async exportedUpdateMasive(sales_orders_ids) {
		try {
			let resp = await axios.post(
				`${process.env.VUE_APP_API_SERVER}/auth/salesorder/exported`,
				{
					sales_orders: sales_orders_ids,
				},
				{
					headers: {
						Authorization: `Bearer ${store.state.acount.token}`,
					},
				}
			);
		} catch (error) {
			throw error;
		}
	}

	async jsonStructurevalidate(payload) {
		try {
			return await axios.post(
				`${process.env.VUE_APP_API_SERVER}/auth/store/purchaceorder/structurevalidation`,
				{
					articles: payload,
				},
				{
					headers: {
						Authorization: `Bearer ${store.state.acount.token}`,
					},
				}
			);

			return response;
		} catch (error) {
			throw error;
		}
	}

	async statusUpdate(payload) {
		try {
			return await axios.put(
				`${process.env.VUE_APP_API_SERVER}/auth/salesorder/${this.salesorder.id}/status`,
				payload,
				{
					headers: {
						Authorization: `Bearer ${store.state.acount.token}`,
					},
				}
			);
		} catch (error) {
			throw error;
		}
	}

	async last() {
		try {
			let response = await axios.get(
				`${process.env.VUE_APP_API_SERVER}/auth/store/salesorder/last`,
				{
					headers: {
						Authorization: `Bearer ${store.state.acount.token}`,
					},
				}
			);

			return response.data.data;
		} catch (error) {
			throw error;
		}
	}
}
